/**
 * ERC Duplicate Reference Validator Adapter for DRC System
 *
 * This validator checks for duplicate component reference designators.
 *
 * Feature-gated via DrcEnabledCheckers.ErcDuplicateReferenceValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
import { createErcProblem, isPortalOrGroundElement } from "./ercUtils";
/**
 * Validator that checks for duplicate component reference designators.
 */
export class ErcDuplicateReferenceValidator {
    reviewType = ReviewType.DesignRuleCheckErcDuplicateReference;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = false;
    async checkForProblems(inputs) {
        const foundProblems = [];
        // Group elements by their reference designator
        const referenceMap = {};
        for (const element of Object.values(inputs.elements)) {
            const reference = element.label;
            // Skip elements without a reference, ground elements, and portal elements
            // Ground elements intentionally share the same label (e.g., "GND") to connect nets
            // Portal elements (Net Portal, Power Net Portal) intentionally share the same label
            // to connect nets across the schematic
            if (!reference || isPortalOrGroundElement(element)) {
                continue;
            }
            if (!referenceMap[reference]) {
                referenceMap[reference] = [];
            }
            referenceMap[reference].push({
                uid: element.uid,
                partName: element.part_version_data_cache?.name ?? "unknown",
            });
        }
        // Report duplicates
        for (const [reference, elements] of Object.entries(referenceMap)) {
            if (elements.length > 1) {
                const elementNames = elements.map((e) => e.partName).join(", ");
                const message = `Reference designator "${reference}" is used by ${elements.length} components: ${elementNames}.`;
                foundProblems.push(createErcProblem(this.problemTypeKey, `${this.problemTypeKey}_${reference}`, message, elements.map((e) => e.uid), elements.map(() => reference)));
            }
        }
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcDuplicateReferenceValidator.js.map